import DetailsTitle from "components/common/detailsPage/DetailsTitle";
import InfoItem from "components/common/detailsPage/InfoItem";
import DetailsShimmer from "components/common/shimmer/DetailsShimmer";
import { NotificationStatusBadge } from "components/common/StatusBadge";
import { usePermission } from "hooks/usePermission";
import { useQueryParam } from "hooks/useQueryParam";
import React, { useEffect } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationDetails } from "store/slices/notificationSlice";
import { NOTIFICATION_TYPE } from "utils/constants";
import { formatUTCDate } from "utils/utils";

const NotificationHistoryDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useQueryParam("id");

  const { canAction } = usePermission();
  const { canView } = canAction("notifications");

  const { loading, notificationDetails } = useSelector(
    (state) => state.Notification
  );

  useEffect(() => {
    if (id && canView) {
      dispatch(getNotificationDetails(id));
    }
  }, [id, canView]);

  const {
    title,
    body,
    createdAt,
    customers,
    isScheduled,
    scheduledTime,
    type,
    status,
  } = notificationDetails || {};

  if (loading) {
    return (
      <div className="page-content">
        <DetailsTitle title={t("Notification Details")} />
        <div className="common_card">
          <DetailsShimmer />
        </div>
      </div>
    );
  }

  if (!canView) return null;

  return (
    <div className="page-content common_details_page notification_details_page">
      <DetailsTitle title={t("Notification Details")} />
      <Row>
        <Col lg={6}>
          <div className="common_card">
            <Row>
              <InfoItem label={t("Title")} value={title?.en} col={{ lg: 6 }} />
              <InfoItem
                label={t("Audience")}
                value={
                  t(
                    NOTIFICATION_TYPE?.find((option) => option?.value === type)
                      ?.name
                  ) || "-"
                }
                col={{ lg: 6 }}
              />
              {isScheduled && (
                <InfoItem
                  label={t("Scheduled Date & Time")}
                  value={formatUTCDate(scheduledTime)}
                  col={{ lg: 6 }}
                  classname="mt-3"
                />
              )}
              <InfoItem
                label={t("Created Date")}
                value={formatUTCDate(createdAt)}
                col={{ lg: 6 }}
                classname="mt-3"
              />
              <InfoItem
                label={t("Status")}
                value={<NotificationStatusBadge status={status} t={t} />}
                col={{ lg: 6 }}
                classname="mt-3"
              />
              <InfoItem
                label={t("Body")}
                value={body?.en}
                col={{ lg: 12 }}
                classname="mt-3"
              />
            </Row>
          </div>
        </Col>
        {type === "specific_customers" && (
          <Col lg={6}>
            <div className="common_card pt-1">
              <Table hover responsive>
                <thead className="t_head">
                  <tr>
                    <th style={{ width: 70 }}>{t("S.No")}</th>
                    <th>{t("Name")}</th>
                    <th>{t("Phone Number")}</th>
                  </tr>
                </thead>
                <tbody>
                  {customers?.length > 0
                    ? customers?.map((item, index) => {
                        const { _id, name, phone } = item || {};
                        return (
                          <tr key={_id}>
                            <td>{index + 1}</td>
                            <td>{name || "-"}</td>
                            <td>{phone || "-"}</td>
                          </tr>
                        );
                      })
                    : ""}
                </tbody>
              </Table>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default NotificationHistoryDetails;
